import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Route, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { NavigationService, ROUTE_METADATA } from 'src/app/core/navigation/services/navigation.service';
import { AuthService, RolePermission } from 'src/app/services';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import 'reflect-metadata';
import { NavbarService } from 'src/app/core/navigation/navbar/services/navbar.service';

export const authGuard: CanActivateFn = (activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
	
	const authService: AuthService = inject(AuthService);
	const localStorage: LocalStorageService = inject(LocalStorageService);
	const navigationService: NavigationService = inject(NavigationService);
	const navbarService: NavbarService = inject(NavbarService);

	while (activatedRouteSnapshot.firstChild && activatedRouteSnapshot.firstChild.firstChild) {
		activatedRouteSnapshot = activatedRouteSnapshot.firstChild;
	}

	const loginRoute: Route = navigationService.getComponentRouteData(ROUTE_METADATA.Login)?.route;
	const forgotPasswordRoute: Route = navigationService.getComponentRouteData(ROUTE_METADATA.ForgotPassword)?.route;
	const redirectAccessRoute: Route = navigationService.getComponentRouteData(ROUTE_METADATA.RedirectAccess)?.route;

	const isLoggedIn = authService.isLoggedIn;
		const isLoginForm = activatedRouteSnapshot.routeConfig.path === 'dealer-portal-auth' || (activatedRouteSnapshot.routeConfig.path === loginRoute?.path && !loginRoute?.path.includes('dashboards/'));
	const isForgotPasswordForm = activatedRouteSnapshot.routeConfig.path === forgotPasswordRoute?.path;
	const isRedirectAccessRouteForm = activatedRouteSnapshot.routeConfig.path === redirectAccessRoute?.path;
	if (isRedirectAccessRouteForm || isForgotPasswordForm) {

	}
	else if (!isLoggedIn && !isLoginForm) {
		navigationService.navigate(ROUTE_METADATA.Login);

		return false;
	}

	if (isLoggedIn && isLoginForm) {
		navigationService.navigate(ROUTE_METADATA.Home);

		return false;
	}

	let navbarItemId: number = navbarService.findNavbarItemIfVisible(activatedRouteSnapshot.routeConfig)?.id ?? -1;

	let permission: RolePermission = localStorage.get<RolePermission[]>(RolePermission.storage_key)?.find(
		(rolePermission) => rolePermission.menuId === navbarItemId
	);
	 
	if (permission && !permission.isVisible) {
		navigationService.navigate(ROUTE_METADATA.Home);
		return false;
	}

	//fixing patch for access urls should be removed in future
	let IsAccessExtraAuth = navbarService.findNavbarItemIfHidden(activatedRouteSnapshot.routeConfig)
	 
	if(!IsAccessExtraAuth)
	{
		navigationService.navigate(ROUTE_METADATA.NotFound);
		 
		return false;
	}
	// let navbarItemIdHidden  = navbarService.findNavbarItemIfHidden(activatedRouteSnapshot.routeConfig)?.id ?? -1;
	// let permissionHidden: RolePermission = localStorage.get<RolePermission[]>(RolePermission.storage_key)?.find(
	// 	(rolePermission) => rolePermission.menuId === navbarItemIdHidden
	// );
	 
	return isLoggedIn || isLoginForm || isForgotPasswordForm || isRedirectAccessRouteForm;
};
